import React from 'react';
import { Nav, ProgressBar } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import Layout from '../layout/layout';
import user from '../../assets/images/profile/avatar.png';
import logout from '../../assets/images/profile/logout.svg';
// import setting from "../../assets/images/profile/setting.svg";
import history from '../../assets/images/profile/history.svg';
import transaction from '../../assets/images/profile/transaction.svg';
import fairness from '../../assets/images/profile/fairness.svg';
import './profile.css';

const Profile = ({ children }) => {
  return (
    <Layout>
      <div className='profile-wrapper'>
        <div className='container'>
          <div className='profile-grid'>
            <div className='profile-sidebar'>
              <div className='profile-user'>
                <div className='user-info'>
                  <div className='user-name'>
                    <img src={user} alt='' />
                    <span>89</span>
                    ENT1T7
                  </div>

                  <div className='logout'>
                    <img src={logout} alt='' /> Logout
                  </div>
                </div>

                <div className='profile-complete'>
                  <ProgressBar now={60} />
                </div>

                <div className='profile-level'>
                  <span>Next Level</span>
                  <span>7,000/10,000 XP</span>
                </div>
              </div>

              <div className='profile-menu'>
                <h5>Menu</h5>
                <Nav>
                  {/* <NavLink to="/settings"><img src={setting} alt="" /> Settings</NavLink> */}
                  <NavLink to='/bethistory'>
                    <img src={history} alt='' /> Bet History
                  </NavLink>
                  <NavLink to='/transactions'>
                    <img src={transaction} alt='' /> Transactions
                  </NavLink>
                  <NavLink to='/fairness'>
                    <img src={fairness} alt='' /> Fairness
                  </NavLink>
                </Nav>
              </div>
            </div>

            <div className='profile-content'>{children}</div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Profile;
